import React from 'react'
import {Link} from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    tqContainer:{
        padding: '30px  0',
        textAlign: 'center',
        '& h2':{
            fontSize: 30,
            color: '#77b43f',
            fontWeight: '700',
            margin: '20px 0'
        },
        '& p':{
            fontSize: 20,
            width: '80%',
            margin: '0 auto',
        }
    },
    thankyou:{
        fontSize: '24px !important',
        fontWeight: 'bold',
        margin: '30px 0 0 !important',
        width: 'auto !important',
    }

}))

const Thankyou = ()=> {
    const classes = useStyles();
    return (
        <div className={classes.tqContainer}>
            <img src={require('../images/success.gif')} width="150" />
            <Typography component="h2"> Submitted Successfully</Typography>
            <Typography component="p">We sincerely appreciate your patience and look forward to your invaluable commitment to reach out to your patients digitally. </Typography>
            <Typography component="p" className={classes.thankyou}>Thank You! </Typography>
        </div>
    )
}

export default Thankyou